module.exports = __webpack_public_path__ + "img/one.13132daa.png";